import React, { useState } from "react";
import {
  Radio,
  Container,
  RadioGroup,
  TextField,
  Stepper,
  StepLabel,
  Step,
  StepConnector,
  Typography,
  Checkbox,
  FormControlLabel,
  FormControl,
  FormLabel,
  Grid,
  Select,
  MenuItem,
  Button,
  List,
  ListItem,
  InputAdornment,
  Box,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/system";
import CheckIcon from "@mui/icons-material/Check";
import axios from "axios";
import {
  FaRegCalendarAlt,
  FaClock,
  FaHourglassHalf,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";
import ReactDatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Footer from "./Footer";

// Styled connector for stepper
const ColorConnector = styled(StepConnector)({
  "& .MuiStepConnector-line": {
    height: 3,
    border: 0,
    backgroundColor: "#e0e0e0", // Directly specifying the color
  },
});

const cleaningOptions = [
  "Unterhaltsreinigung",
  "Büroreinigung",
  "Umzugsreinigung",
  "Grundreinigung",
  "Professionelle Fensterreinigung",
  "Bauendreinigung",
  "Fassadenreinigung",
];

const intervals = ["Einmalig", "Wöchentlich", "14-tägig", "Monatlich"];

const contactMethods = [
  { value: "phone", label: "Telefon" },
  { value: "email", label: "Email" },
];

const optionsZimmer = [
  { value: "1-1.5", label: "1 - 1,5" },
  { value: "2-2.5", label: "2 - 2,5" },
  { value: "3-3.5", label: "3 - 3,5" },
  { value: "4-4.5", label: "4 - 4,5" },
  { value: "5-5.5", label: "5 - 5,5" },
  { value: "6-6.5", label: "6 - 6,5" },
  { value: "7-7.5", label: "7 - 7,5" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "Mehr als 10 Zimmer", label: "Mehr als 10 Zimmer" },
];

const optionsBaeder = [
  { value: "1-1.5", label: "1 - 1,5" },
  { value: "2-2.5", label: "2 - 2,5" },
  { value: "3-3.5", label: "3 - 3,5" },
  { value: "4-4.5", label: "4 - 4,5" },
  { value: "5-5.5", label: "5 - 5,5" },
  { value: "6-6.5", label: "6 - 6,5" },
  { value: "7-7.5", label: "7 - 7,5" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "Mehr als 10 Bäder", label: "Mehr als 10 Bäder" },
];

const hours = Array.from({ length: 12 }, (_, i) =>
  String(i + 1).padStart(2, "0")
);
const minutes = [];
for (let i = 1; i <= 59; i++) {
  minutes.push(i < 10 ? `0${i}` : `${i}`);
}
const ampm = ["AM", "PM"];

const steps = [
  { number: 1, label: "Reinigungsart" },
  { number: 2, label: "Mehr" },
  { number: 3, label: "Objektdetails" },
  { number: 4, label: "Terminplanung" },
  { number: 5, label: "Kundendaten" },
];
const options = [
  { value: "Nein", label: "Nein" },
  { value: "Ja", label: "Ja" },
];

const Cleaningform = () => {
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const isSmallScreen = useMediaQuery("(max-width: 400px)");

  const [step, setStep] = useState(1);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [interval, setInterval] = useState("");
  const [step3Errors, setStep3Errors] = useState({});
  const [formData, setFormData] = useState({
    vorname: "",
    nachname: "",
    objektart: "",
    zimmer: "",
    baeder: "",
    groesse: "",
    date: "",
    hour: "",
    minute: "",
    ampm: "",
    kontaktMethode: "",
    telefon: "",
    email: "",
    straße: "",
    stadt: "",
    plz: "",
    addons: {
      balcony: "",
      cabinets: "",
      basement: "",
      fridgeOvenInside: "",
      garage: "",
      sanitäranlagen: "",
      fenster: "",
      lamellen: "",
      herd: "",
      geschirrspul: "",
      garagekehren: "",
      fugen: "",
      Rolladen: "",
      Raffstore: "",
      wunsche: "",
    },
    interval,
  });
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [selectedContactMethod, setSelectedContactMethod] = useState(
    formData.contactMethod || ""
  );
  const navigate = useNavigate();

  const handleContactMethodChange = (event) => {
    const value = event.target.value;
    setSelectedContactMethod(value);
    setFormData({ ...formData, contactMethod: value });
    setErrors({ ...errors, contactMethod: false });
  };

  // Web3Forms API endpoint and your API key
  const WEB3FORMS_API_URL = "https://api.web3forms.com/submit";
  const WEB3FORMS_API_KEY = "8ba0eda1-f2cc-4b67-8b87-429a9bda01dc"; // Replace with your Web3Forms API key

  // Handle form data changes
  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Form submit handler
  const handleSubmit = async () => {
    const formPayload = {
      ...formData,
      interval,
      access_key: WEB3FORMS_API_KEY,
      addons: Object.entries(formData.addons)
        .filter(([_, value]) => value) // Only non-empty addons
        .map(([key, value]) => `${key}: ${value}`)
        .join(", "),
      cleaningOptions: selectedOptions.join(", "), // ✅ This line is important
    };

    try {
      const response = await axios.post(WEB3FORMS_API_URL, formPayload);
      if (response.data.success) {
        setSuccess(true);
        setOpenSnackbar(true); // Show popup
        setTimeout(() => {
          navigate("/kontakt");
        }, 2000);
      } else {
        setErrors({
          ...errors,
          submit: "Fehler beim Absenden der Formulardaten",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setErrors({ ...errors, submit: "Etwas ist schief gelaufen" });
    }
  };

  // Handle next step
  const handleNext = () => {
    if (step === 5) {
      handleSubmit(); // Call handleSubmit directly without event
    } else {
      setStep(step + 1);
    }
  };

  const handleIntervalChange = (value) => {
    setInterval(value);
  };

  const handleAddonChange = (addon, value) => {
    setFormData((prev) => ({
      ...prev,
      addons: {
        ...prev.addons,
        [addon]: value, // Update the selected value for the addon
      },
    }));
  };

  // Handle previous step
  const handleBack = () => {
    setStep(step - 1);
  };

  return (
    <div>
     <Box
  sx={{
    width: { xs: "100%", sm: "90%" },
    mb: { xs: 3, sm: 5 },
    mt: { xs: 4, sm: 6 },
    mx: "auto",
  }}
>
  <Stepper
    activeStep={step - 1}
    alternativeLabel
    connector={isSmallScreen ? null : <ColorConnector />} // No line on mobile
    sx={{
      display: "flex",
      flexDirection: { xs: "column", sm: "row" },
      alignItems: "center",
      justifyContent: "center",
      gap: { xs: 1, sm: 2 },
    }}
  >
    {steps.map((s) =>
      isSmallScreen ? (
        step === s.number && ( // Show only the active step on mobile
          <Step key={s.number}>
            <StepLabel
              StepIconProps={{
                sx: {
                  fontSize: { xs: 20, sm: 24 }, // Slightly larger font size on mobile
                  color:
                    step === s.number
                      ? "primary.main"
                      : step > s.number
                      ? "#70C9C0 !important"
                      : "grey.500",
                  fontWeight: "bold",
                },
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: "1rem", sm: "1.2rem" }, // Larger text on mobile
                  textAlign: "center",
                  display: "block", // Always display on mobile
                }}
              >
                {`${s.label}`} {/* Display number and label */}
              </Typography>
            </StepLabel>
          </Step>
        )
      ) : (
        <Step key={s.number}>
          <StepLabel
            StepIconProps={{
              sx: {
                fontSize: { xs: 16, sm: 24 },
                color:
                  step === s.number
                    ? "primary.main"
                    : step > s.number
                    ? "#70C9C0 !important"
                    : "grey.500",
                fontWeight: "bold",
              },
            }}
          >
            <Typography
              variant="caption"
              sx={{
                fontSize: { xs: "0.875rem", sm: "1rem" },
                textAlign: "center",
                display: { xs: "inline", sm: "block" },
              }}
            >
              {s.label}
            </Typography>
          </StepLabel>
        </Step>
      )
    )}
  </Stepper>
</Box>


      <form onSubmit={handleSubmit}>
        {step === 1 && (
          <Box sx={{ maxWidth: 1200, mx: "auto", p: 4 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", mb: 2, textAlign: "left" }}
            >
              Kostenlose Offerte in wenigen Sekunden
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "#1e3a8a",
                mb: 2,
                textAlign: "left",
              }}
            >
              Welche Reinigungsleistung dürfen wir für Sie übernehmen?
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "gray", mb: 4, textAlign: "left" }}
            >
              Bitte wählen Sie hier Ihre gewünschte Dienstleistung aus (Mehrfachauswahl
              möglich): <span style={{ color: "red" }}>*</span>
            </Typography>

            {cleaningOptions.map((option) => (
              <Box
                key={option}
                sx={{ display: "flex", alignItems: "center", mb: 2 }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedOptions.includes(option)}
                      onChange={() => {
                        setSelectedOptions((prev) =>
                          prev.includes(option)
                            ? prev.filter((o) => o !== option)
                            : [...prev, option]
                        );
                      }}
                      icon={
                        <span
                          style={{
                            borderRadius: 3,
                            width: 20,
                            height: 20,
                            border: "1px solid #1976d2",
                            display: "inline-block",
                          }}
                        />
                      }
                      checkedIcon={
                        <span
                          style={{
                            borderRadius: 3,
                            width: 20,
                            height: 20,
                            backgroundColor: "#01b8c3",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <CheckIcon style={{ color: "white", fontSize: 16 }} />
                        </span>
                      }
                    />
                  }
                  label={<Typography variant="body1">{option}</Typography>}
                  sx={{ display: "flex", alignItems: "center" }}
                />
              </Box>
            ))}
          </Box>
        )}
        {step === 2 && selectedOptions.includes("Unterhaltsreinigung") && (
          <Box sx={{ maxWidth: 1200, mx: "auto", p: 4 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", mb: 4, textAlign: "left" }}
            >
              Unterhaltsreinigung
            </Typography>
            <Typography
              variant="body1"
              sx={{ mb: 6, textAlign: "left", color: "gray" }}
            >
              Die Unterhaltsreinigung kann für alle denkbaren Objekte
              durchgeführt werden und umfasst dabei die Reinigung von
              Treppenhäusern oder Büroräumen und Geschäftsstellen genauso wie
              die Reinigung von Arztpraxen, Schulen, Kindertagesstätten aber
              auch Supermärkten oder Einkaufszentren oder privaten Haushalten.
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#1e3a8a",
                mb: 2,
                textAlign: "left",
              }}
            >
              Intervall*
            </Typography>
            <Typography
              variant="body2"
              sx={{
                mb: 2,
                fontStyle: "italic",
                color: "gray",
                textAlign: "left",
              }}
            >
              Wie oft soll das Objekt gereinigt werden?
            </Typography>

            <Box
              sx={{
                mb: 6,
                display: "flex",
                gap: 2, // Reduced gap for small screens
                flexDirection: { xs: "column", sm: "row" }, // Stack on small screens, row on larger screens
                alignItems: "flex-start", // Align the items to start for smaller screens
              }}
            >
              {intervals.map((val) => (
                <FormControlLabel
                  key={val}
                  control={
                    <Radio
                      name="interval"
                      value={val.toLowerCase()}
                      checked={interval === val.toLowerCase()}
                      onChange={() => handleIntervalChange(val.toLowerCase())}
                      sx={{ mr: 2 }}
                    />
                  }
                  label={val}
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "flex-start", // Align label to the start
                    width: "100%", // Make each label take full width on small screens
                  }}
                />
              ))}
            </Box>

            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 2, textAlign: "left" }}
            >
              Zusatzleistungen
            </Typography>
            <Grid container spacing={4} sx={{ mb: 6 }}>
              <Grid item xs={12} sm={4}>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: "medium", mb: 1 }}
                >
                  Balkon/Terrasse kehren und wischen
                </Typography>
                <Select
                  fullWidth
                  value={formData.addons.balcony}
                  onChange={(e) => handleAddonChange("balcony", e.target.value)}
                  displayEmpty
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="" disabled>
                    Bitte auswählen
                  </MenuItem>
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: "medium", mb: 1 }}
                >
                  Schränke von innen reinigen
                </Typography>
                <Select
                  fullWidth
                  displayEmpty
                  value={formData.addons.cabinets}
                  onChange={(e) =>
                    handleAddonChange("cabinets", e.target.value)
                  }
                  options={options}
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="">Bitte auswählen</MenuItem>

                  {/* Dynamically render options */}
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: "medium", mb: 1 }}
                >
                  Keller kehren und wischen
                </Typography>
                <Select
                  fullWidth
                  value={formData.addons.basement}
                  displayEmpty
                  onChange={(e) =>
                    handleAddonChange("basement", e.target.value)
                  }
                  options={options}
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="">Bitte auswählen</MenuItem>

                  {/* Dynamically render options */}
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: "medium", mb: 1 }}
                >
                  Kühlschrank & Ofen innen reinigen
                </Typography>
                <Select
                  fullWidth
                  value={formData.addons.fridgeOvenInside}
                  displayEmpty
                  onChange={(e) =>
                    handleAddonChange("fridgeOvenInside", e.target.value)
                  }
                  options={options}
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="">Bitte auswählen</MenuItem>

                  {/* Dynamically render options */}
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: "medium", mb: 1 }}
                >
                  Garage kehren und wischen
                </Typography>
                <Select
                  fullWidth
                  value={formData.addons.garage}
                  displayEmpty
                  onChange={(e) => handleAddonChange("garage", e.target.value)}
                  options={options}
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="">Bitte auswählen</MenuItem>

                  {/* Dynamically render options */}
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
          </Box>
        )}
        {step === 2 && selectedOptions.includes("Büroreinigung") && (
          <Box sx={{ maxWidth: 1200, mx: "auto", p: 4 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", mb: 4, textAlign: "left" }}
            >
              Büroreinigung
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#1e3a8a",
                mb: 2,
                textAlign: "left",
              }}
            >
              Intervall*
            </Typography>
            <Typography
              variant="body2"
              sx={{
                mb: 2,
                fontStyle: "italic",
                color: "gray",
                textAlign: "left",
              }}
            >
              Wie oft soll das Objekt gereinigt werden?
            </Typography>

            <Box sx={{ mb: 2, display: "flex", gap: 4 }}>
              {intervals.map((val) => (
                <FormControlLabel
                  key={val}
                  control={
                    <Radio
                      name="interval"
                      value={val.toLowerCase()}
                      checked={interval === val.toLowerCase()}
                      onChange={() => handleIntervalChange(val.toLowerCase())}
                      sx={{ mr: 2 }}
                    />
                  }
                  label={val}
                  sx={{ display: "inline-flex", alignItems: "center" }}
                />
              ))}
            </Box>

            <Box sx={{ maxWidth: 1200, p: 2, textAlign: "left" }}>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#1e3a8a", mb: 4 }}
              >
                Inklusivleistungen
              </Typography>
              <Typography variant="body2" sx={{ mb: 6, color: "gray" }}>
                Folgende Leistungen sind in einer Unterhaltsreinigung bereits
                inkludiert:
              </Typography>

              {/* Sämtliche Räume */}
              <Box sx={{ mb: 6 }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "gray", mb: 2 }}
                >
                  Sämtliche Räume:
                </Typography>
                <List>
                  <ListItem>Staubsaugen</ListItem>
                  <ListItem>Boden reinigen</ListItem>
                  <ListItem>Spinnweben entfernen</ListItem>
                  <ListItem>Alle Oberflächen entstauben und abwischen</ListItem>
                  <ListItem>Spiegel abwischen</ListItem>
                </List>
              </Box>

              {/* Badezimmer */}
              <Box sx={{ mb: 6 }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "gray", mb: 2 }}
                >
                  Badezimmer:
                </Typography>
                <List>
                  <ListItem>Toiletten reinigen und desinfizieren</ListItem>
                  <ListItem>Waschbecken reinigen und desinfizieren</ListItem>
                  <ListItem>
                    Dusche/Badewanne reinigen und desinfizieren
                  </ListItem>
                </List>
              </Box>

              {/* Küche */}
              <Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "gray", mb: 2 }}
                >
                  Küche:
                </Typography>
                <List>
                  <ListItem>Herd von außen reinigen</ListItem>
                  <ListItem>Ofen von außen reinigen</ListItem>
                  <ListItem>Kühlschrank von außen reinigen</ListItem>
                </List>
              </Box>
            </Box>

            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 2, textAlign: "left" }}
            >
              Zusatzleistungen
            </Typography>
            <Grid container spacing={4} sx={{ mb: 6 }}>
              <Grid item xs={12} sm={4}>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: "medium", mb: 1 }}
                >
                  Sanitäranlagen reinigen & desinfizieren
                </Typography>
                <Select
                  fullWidth
                  value={formData.addons.sanitäranlagen}
                  displayEmpty
                  onChange={(e) =>
                    handleAddonChange("sanitäranlagen", e.target.value)
                  }
                  options={options}
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="" disabled>
                    Bitte auswählen
                  </MenuItem>
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: "medium", mb: 1 }}
                >
                  Fenster reinigen
                </Typography>
                <Select
                  fullWidth
                  value={formData.addons.fenster}
                  displayEmpty
                  onChange={(e) => handleAddonChange("fenster", e.target.value)}
                  options={options}
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="" disabled>
                    Bitte auswählen
                  </MenuItem>
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: "medium", mb: 1 }}
                >
                  Lamellen, Rolladen, Raffstore reinigen
                </Typography>
                <Select
                  fullWidth
                  value={formData.addons.lamellen}
                  displayEmpty
                  onChange={(e) =>
                    handleAddonChange("lamellen", e.target.value)
                  }
                  options={options}
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="" disabled>
                    Bitte auswählen
                  </MenuItem>
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: "medium", mb: 1 }}
                >
                  Herd, Ofen, Kühlschrank von innen & außen reinigen
                </Typography>
                <Select
                  fullWidth
                  value={formData.addons.herd}
                  displayEmpty
                  onChange={(e) => handleAddonChange("herd", e.target.value)}
                  options={options}
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="" disabled>
                    Bitte auswählen
                  </MenuItem>
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: "medium", mb: 1 }}
                >
                  Geschirrspülmaschine entleeren und einräumen
                </Typography>
                <Select
                  fullWidth
                  value={formData.addons.geschirrspul}
                  displayEmpty
                  onChange={(e) =>
                    handleAddonChange("geschirrspul", e.target.value)
                  }
                  options={options}
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="" disabled>
                    Bitte auswählen
                  </MenuItem>
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: "medium", mb: 1 }}
                >
                  Garage reinigen
                </Typography>
                <Select
                  fullWidth
                  value={formData.addons.garage}
                  displayEmpty
                  onChange={(e) => handleAddonChange("garage", e.target.value)}
                  options={options}
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="" disabled>
                    Bitte auswählen
                  </MenuItem>
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: "medium", mb: 1 }}
                >
                  Kühlschrank & Ofen innen reinigen
                </Typography>
                <Select
                  fullWidth
                  value={formData.addons.fridgeOvenInside}
                  displayEmpty
                  onChange={(e) =>
                    handleAddonChange("fridgeOvenInside", e.target.value)
                  }
                  options={options}
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="" disabled>
                    Bitte auswählen
                  </MenuItem>
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: "medium", mb: 1 }}
                >
                  Garage kehren und wischen
                </Typography>
                <Select
                  fullWidth
                  value={formData.addons.garagekehren}
                  displayEmpty
                  onChange={(e) =>
                    handleAddonChange("garagekehren", e.target.value)
                  }
                  options={options}
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="" disabled>
                    Bitte auswählen
                  </MenuItem>
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
          </Box>
        )}
        {step === 2 && selectedOptions.includes("Umzugsreinigung") && (
          <Box sx={{ maxWidth: 1200, mx: "auto", p: 4 }}>
            {/* Title */}
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", mb: 4, textAlign: "left" }}
            >
              Umzugsreinigung
            </Typography>

            {/* Inklusivleistungen */}
            <Box sx={{ maxWidth: 1200, textAlign: "left", p: 2 }}>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#1e3a8a", mb: 4 }}
              >
                Inklusivleistungen
              </Typography>
              <Typography variant="body2" sx={{ mb: 6, color: "gray" }}>
                Folgende Leistungen sind in einer Umzugsreinigung bereits
                inkludiert:
              </Typography>

              <Box sx={{ mb: 6 }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "gray", mb: 2 }}
                >
                  Sämtliche Räume:
                </Typography>
                <List>
                  <ListItem>Sämtliche Räume</ListItem>
                  <ListItem>Küche</ListItem>
                  <ListItem>Badezimmer/Gäste WC</ListItem>
                  <ListItem>Fenster</ListItem>
                </List>
              </Box>
            </Box>

            {/* Zusatzleistungen */}
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 2, textAlign: "left" }}
            >
              Zusatzleistungen
            </Typography>

            <Grid container spacing={4} sx={{ mb: 6 }}>
              <Grid item xs={12}>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: "medium", mb: 1 }}
                >
                  Herd, Ofen & Kühlschrank von innen und außen reinigen
                </Typography>
                <Select
                  fullWidth
                  value={formData.addons.herd}
                  displayEmpty
                  onChange={(e) => handleAddonChange("herd", e.target.value)}
                  options={options}
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="" disabled>
                    Bitte auswählen
                  </MenuItem>
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
          </Box>
        )}
        {step === 2 && selectedOptions.includes("Grundreinigung") && (
          <Container maxWidth="lg">
            {/* Title */}
            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              fontWeight="600"
            >
              Grundreinigung
            </Typography>

            {/* Inklusivleistungen */}
            <Box maxWidth="md" mb={6}>
              <Typography
                variant="h5"
                component="h2"
                color="primary"
                fontWeight="bold"
                gutterBottom
              >
                Inklusivleistungen
              </Typography>
              <Typography variant="body1" color="text.secondary" paragraph>
                Folgende Leistungen sind in einer Umzugsreinigung bereits
                inkludiert:
              </Typography>

              {/* General Leistungen */}
              <Box mb={4}>
                <List>
                  {[
                    "Wände und Decken entstauben",
                    "Türen reinigen",
                    "Abfalleimer leeren",
                    "Staubsaugen",
                    "Boden reinigen",
                    "Spiegel reinigen",
                    "Fenster reinigen",
                    "Storen reinigen",
                  ].map((item, index) => (
                    <ListItem key={index} sx={{ display: "list-item", pl: 2 }}>
                      <Typography variant="body1">{item}</Typography>
                    </ListItem>
                  ))}
                </List>
              </Box>

              {/* Badezimmer */}
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                Badezimmer:
              </Typography>
              <List sx={{ mb: 4 }}>
                {[
                  "Sämtliche Nasszellen reinigen",
                  "Dusche/Bad reinigen & desinfizieren",
                  "Toiletten reinigen & desinfizieren",
                  "Waschbecken reinigen & desinfizieren",
                ].map((item, index) => (
                  <ListItem key={index} sx={{ display: "list-item", pl: 2 }}>
                    <Typography variant="body1">{item}</Typography>
                  </ListItem>
                ))}
              </List>

              {/* Küche */}
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                Küche:
              </Typography>
              <List sx={{ mb: 4 }}>
                {[
                  "Ofen innen + außen",
                  "Kühlschrank innen + außen",
                  "Dunstabzug + Filter reinigen",
                ].map((item, index) => (
                  <ListItem key={index} sx={{ display: "list-item", pl: 2 }}>
                    <Typography variant="body1">{item}</Typography>
                  </ListItem>
                ))}
              </List>

              {/* Sonstige Räume */}
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                Sonstige Räume:
              </Typography>
              <List>
                {[
                  "Balkon/Terrasse kehren",
                  "Keller kehren",
                  "Garage kehren",
                ].map((item, index) => (
                  <ListItem key={index} sx={{ display: "list-item", pl: 2 }}>
                    <Typography variant="body1">{item}</Typography>
                  </ListItem>
                ))}
              </List>
            </Box>
          </Container>
        )}
        {step === 2 &&
          selectedOptions.includes("Professionelle Fensterreinigung") && (
            <Container maxWidth="lg">
              <Typography
                variant="h4"
                component="h1"
                fontWeight="600"
                gutterBottom
              >
                Professionelle Fensterreinigung
              </Typography>

              <Typography variant="body1" color="text.secondary" paragraph>
                Erfreuen Sie sich in Ihrem trauten Heim aber auch in
                Bürogebäuden an turnusmäßig gepflegten Fenstern, die immer einen
                guten Eindruck bei Freunden, Kollegen oder Geschäftspartnern
                machen.
              </Typography>

              {/* Intervall */}
              <Box mb={3}>
                <Typography variant="h6" color="primary" gutterBottom>
                  Intervall*
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontStyle="italic"
                >
                  Wie oft soll das Objekt gereinigt werden?
                </Typography>

                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    name="interval"
                    value={interval}
                    onChange={(e) => handleIntervalChange(e.target.value)}
                  >
                    {intervals.map((val) => (
                      <FormControlLabel
                        key={val}
                        value={val.toLowerCase()}
                        control={<Radio />}
                        label={val}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Box>

              {/* Inklusivleistungen */}
              <Box maxWidth="md" mb={5}>
                <Typography
                  variant="h5"
                  color="primary"
                  fontWeight="bold"
                  gutterBottom
                >
                  Inklusivleistungen
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph>
                  Folgende Leistungen sind in einer professionellen
                  Fensterreinigung bereits inkludiert:
                </Typography>

                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography
                    component="li"
                    variant="body1"
                    color="text.primary"
                  >
                    Glasreinigung inkl. Rahmen
                  </Typography>
                  <Typography
                    component="li"
                    variant="body1"
                    color="text.primary"
                  >
                    Material und Anfahrt inkl.
                  </Typography>
                </Box>
              </Box>

              {/* Zusatzleistungen */}
              <Typography variant="h5" gutterBottom>
                Zusatzleistungen
              </Typography>
              <Typography variant="body1" paragraph>
                Nachfolgend können Sie Zusatzleistungen beauftragen
              </Typography>

              <Grid container spacing={3} mb={5}>
                {/* Fugen und Falzen */}
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="caption"
                    fontWeight="medium"
                    gutterBottom
                    display="block"
                  >
                    Fugen und Falzen
                  </Typography>
                  <Select
                    fullWidth
                    options={options}
                    value={formData.addons.fugen}
                    displayEmpty
                    onChange={(e) => handleAddonChange("fugen", e.target.value)}
                  >
                    <MenuItem value="" disabled>
                      Bitte auswählen
                    </MenuItem>
                    {options.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {/* Lamellen */}
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="caption"
                    fontWeight="medium"
                    gutterBottom
                    display="block"
                  >
                    Lamellen
                  </Typography>
                  <Select
                    fullWidth
                    options={options}
                    value={formData.addons.lamellen}
                    displayEmpty
                    onChange={(e) =>
                      handleAddonChange("lamellen", e.target.value)
                    }
                  >
                    <MenuItem value="" disabled>
                      Bitte auswählen
                    </MenuItem>
                    {options.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {/* Raffstore */}
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="caption"
                    fontWeight="medium"
                    gutterBottom
                    display="block"
                  >
                    Raffstore
                  </Typography>
                  <Select
                    fullWidth
                    options={options}
                    value={formData.addons.Raffstore}
                    displayEmpty
                    onChange={(e) =>
                      handleAddonChange("Raffstore", e.target.value)
                    }
                  >
                    <MenuItem value="" disabled>
                      Bitte auswählen
                    </MenuItem>
                    {options.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {/* Rolladen */}
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="caption"
                    fontWeight="medium"
                    gutterBottom
                    display="block"
                  >
                    Rolladen
                  </Typography>
                  <Select
                    fullWidth
                    options={options}
                    value={formData.addons.Rolladen}
                    displayEmpty
                    onChange={(e) =>
                      handleAddonChange("Rolladen", e.target.value)
                    }
                  >
                    <MenuItem value="" disabled>
                      Bitte auswählen
                    </MenuItem>
                    {options.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>
            </Container>
          )}
        {step === 2 && selectedOptions.includes("Bauendreinigung") && (
          <Container maxWidth="lg">
            {/* Title */}
            <Typography variant="h4" fontWeight={600} gutterBottom>
              Bauendreinigung
            </Typography>
            <Typography variant="body2" paragraph>
              Ganz gleich, ob es sich dabei um ein Einfamilienhaus, ein
              Mehrfamilienhaus, ein Gewerbeobjekt, ein Büro, eine Industriehalle
              oder andere Räumlichkeiten handelt … In der folgenden Liste finden
              Sie eine Übersicht aller Maßnahmen, die unser erfahrenes
              Reinigungsunternehmen zum Ende oder Abschluss eines Baus für Sie
              übernimmt.
            </Typography>

            {/* Inklusivleistungen */}
            <Box maxWidth="md" mb={5}>
              <Typography
                variant="h5"
                color="primary"
                fontWeight="bold"
                gutterBottom
              >
                Inklusivleistungen
              </Typography>
              <Typography variant="body1" color="text.secondary" paragraph>
                Folgende Leistungen sind in einer Bauendreinigung bereits
                inkludiert:
              </Typography>

              <Box component="ul" sx={{ pl: 3 }}>
                {[
                  "Entfernung von Schutt sowie Bauresten",
                  "Entsorgung von Müll und Verpackungen",
                  "Beseitigung von Staub",
                  "Rückstände beispielsweise von überschüssigem Kleber, Fugenmasse oder",
                  "Zement",
                  "Klebefolien sowie -streifen",
                  "Rückstände von Farben und Lacken",
                  "Verschmutzungen an Türen, Fenstern, Heizungen und vielen mehr",
                  "Reinigung von Fließen",
                  "Entfernen von Verschmutzungen auf Lichtschaltern und Steckdosen",
                  "Reinigung von Bodenbelägen",
                  "Versiegelung und Erstpflege von Fußböden",
                  "Unterhaltsreinigung alle Räume inklusive sanitärer Anlagen",
                ].map((item, index) => (
                  <Typography
                    key={index}
                    component="li"
                    variant="body1"
                    color="text.primary"
                  >
                    {item}
                  </Typography>
                ))}
              </Box>
            </Box>

            {/* Zusatzleistungen */}
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Zusatzleistungen
            </Typography>

            <Grid container spacing={3} mb={6}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="standard"
                  label="Ihre Wünsche"
                  value={formData.addons.wunsche || ""}
                  onChange={(e) => handleAddonChange("wunsche", e.target.value)}
                  InputProps={{
                    sx: {
                      borderBottom: "1px solid rgba(0,0,0,0.3)",
                      color: "text.primary",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Container>
        )}
        {step === 2 && selectedOptions.includes("Fassadenreinigung") && (
          <Container maxWidth="lg">
            {/* Title */}
            <Typography variant="h4" fontWeight={600} gutterBottom>
              Fassadenreinigung
            </Typography>

            {/* Description */}
            <Typography variant="body2" paragraph>
              Verschmutzungen von Abgasen, Algen, Moose und Pilze, Feuchtigkeit,
              Wind, Hagel und Temperaturschwankungen setzen dem Äußeren Ihres
              Hauses jeden Tag zu. Im Laufe der Jahre hinterlässt dies Spuren an
              der Fassade. Wenn Sie regelmäßig die Fassade reinigen, bleibt Ihr
              Haus geschützt. Spätestens, wenn Sie Ihr Haus verkaufen wollen,
              ist eine Fassadenreinigung notwendig. Dies steigert den Wert Ihres
              Hauses und führt unter Umständen zu einem schnelleren Verkauf.
            </Typography>
          </Container>
        )}

        {step === 3 && (
          <Container maxWidth="lg">
            <Typography
              variant="h4"
              fontWeight="600"
              gutterBottom
              sx={{ mb: 5 }}
            >
              Angaben zum Objekt
            </Typography>

            {/* Objektart */}
            <FormControl
              fullWidth
              component="fieldset"
              sx={{
                mb: 5,
                display: "flex",
                flexDirection: {
                  xs: "column",
                  sm: "column",
                  md: "row",
                  lg: "row",
                }, // Correct responsive syntax
                alignItems: "flex-start",
                gap: 2, // Optional: Add some space between items
              }}
              error={step3Errors.objektart}
            >
              <FormLabel
                fullWidth
                component="legend"
                sx={{
                  fontSize: 22,
                  fontWeight: 600,
                  color: step3Errors.objektart ? "error.main" : "primary.main",
                  mb: 2,
                  textAlign: "left",
                }}
              >
                Objektart*
              </FormLabel>
              <RadioGroup
                fullWidth
                row={false} // Start as a column by default
                name="objektart"
                value={formData.objektart}
                onChange={(e) => {
                  setFormData({ ...formData, objektart: e.target.value });
                  setStep3Errors({ ...step3Errors, objektart: false });
                }}
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" }, // Stack vertically on small screens
                  flexWrap: "wrap", // Handle overflow on medium and large screens
                  gap: 1, // Space between radio buttons
                }}
              >
                {[
                  "Gewerbe",
                  "Wohnung",
                  "Maisonette",
                  "Einfamilienhaus",
                  "Mehrfamilienhaus",
                  "Attika",
                ].map((type) => (
                  <FormControlLabel
                    key={type}
                    value={type}
                    control={
                      <Radio
                        sx={{
                          color: "red",
                          "&.Mui-checked": { color: "green" },
                        }}
                      />
                    }
                    label={type}
                    sx={{
                      width: { xs: "100%", sm: "auto" }, // Full width on small screens
                      textAlign: "left",
                    }}
                  />
                ))}
              </RadioGroup>
            </FormControl>

            {/* Anzahl Zimmer */}
            <Box sx={{ mb: 5 }}>
              <FormLabel
                component="legend"
                sx={{
                  fontSize: 22,
                  fontWeight: 600,
                  color: step3Errors.zimmer ? "error.main" : "primary.main",
                  mb: 2,
                  display: "block",
                }}
              >
                Anzahl Zimmer*
              </FormLabel>
              <Select
                fullWidth
                value={formData.zimmer || ""}
                onChange={(e) => {
                  setFormData({ ...formData, zimmer: e.target.value });
                  setStep3Errors({ ...step3Errors, zimmer: false });
                }}
                displayEmpty
                renderValue={(selected) => {
                  return selected
                    ? optionsZimmer.find((o) => o.value === selected)?.label
                    : "Bitte auswählen";
                }}
              >
                <MenuItem value="">Bitte auswählen</MenuItem>
                {optionsZimmer.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            {/* Anzahl Bäder */}
            <Box sx={{ mb: 5 }}>
              <FormLabel
                component="legend"
                sx={{
                  fontSize: 22,
                  fontWeight: 600,
                  color: step3Errors.baeder ? "error.main" : "primary.main",
                  mb: 2,
                  display: "block",
                }}
              >
                Anzahl Bäder*
              </FormLabel>
              <Select
                fullWidth
                value={formData.baeder || ""}
                displayEmpty
                onChange={(e) => {
                  setFormData({ ...formData, baeder: e.target.value });
                  setStep3Errors({ ...step3Errors, baeder: false });
                }}
                renderValue={(selected) => {
                  return selected
                    ? optionsBaeder.find((o) => o.value === selected)?.label
                    : "Bitte auswählen";
                }}
              >
                <MenuItem value="" disabled>
                  Bitte auswählen
                </MenuItem>
                {optionsBaeder.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            {/* Größe Objekt */}
            <Box sx={{ mb: 5 }}>
              <FormLabel
                component="legend"
                sx={{
                  fontSize: 22,
                  fontWeight: 600,
                  color: step3Errors.groesse ? "error.main" : "primary.main",
                  mb: 2,
                  display: "block",
                }}
              >
                Größe Objekt in m²*
              </FormLabel>
              <TextField
                fullWidth
                variant="standard"
                type="number"
                placeholder="m²"
                value={formData.groesse}
                onChange={(e) => {
                  setFormData({ ...formData, groesse: e.target.value });
                  setStep3Errors({ ...step3Errors, groesse: false });
                }}
                error={step3Errors.groesse}
                required
              />
            </Box>
          </Container>
        )}
        {step === 4 && (
          <Box sx={{ maxWidth: 800, mx: "auto", p: 4 }}>
            {step === 4 && (
              <>
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                  Reinigungstermin
                </Typography>
                <Typography color="text.secondary" mb={4}>
                  An welchem Datum soll die Reinigung durchgeführt werden?
                </Typography>

                {/* Date Picker (using React Datepicker) */}
                <Box mb={4}>
                  <Typography
                    variant="h6"
                    color={errors.date ? "error" : "primary"}
                    gutterBottom
                  >
                    Datum & Uhrzeit*
                  </Typography>
                  <ReactDatePicker
                    selected={formData.date}
                    onChange={(date) => handleChange("date", date)}
                    dateFormat="MM/dd/yyyy"
                    placeholderText="Datum auswählen"
                    customInput={
                      <TextField
                        fullWidth
                        error={Boolean(errors.date)}
                        helperText={errors.date && "Bitte ein Datum wählen"}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaRegCalendarAlt />
                            </InputAdornment>
                          ),
                        }}
                      />
                    }
                  />
                </Box>

                {/* Time Selectors */}
                <Grid container spacing={3} mb={4}>
                  {/* Hour */}
                  <Grid item xs={12} md={4}>
                    <TextField
                      select
                      label="Stunde*"
                      fullWidth
                      value={formData.hour || ""}
                      onChange={(e) => handleChange("hour", e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <FaClock />
                          </InputAdornment>
                        ),
                      }}
                    >
                      {hours.map((hour) => (
                        <MenuItem key={hour} value={hour}>
                          {hour}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  {/* Minute */}
                  <Grid item xs={12} md={4}>
                    <TextField
                      select
                      label="Minuten*"
                      fullWidth
                      value={formData.minute || ""}
                      onChange={(e) => handleChange("minute", e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <FaHourglassHalf />
                          </InputAdornment>
                        ),
                      }}
                    >
                      {minutes.map((minute) => (
                        <MenuItem key={minute} value={minute}>
                          {minute}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  {/* AM/PM */}
                  <Grid item xs={12} md={4}>
                    <TextField
                      select
                      label="AM/PM"
                      fullWidth
                      value={formData.ampm || ""}
                      onChange={(e) => handleChange("ampm", e.target.value)}
                    >
                      {ampm.map((period) => (
                        <MenuItem key={period} value={period}>
                          {period}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
              </>
            )}
          </Box>
        )}

        {/* Step 5 */}
        {step === 5 && (
          <Box sx={{ maxWidth: 1200, mx: "auto", p: 4 }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              Ihre Kontaktdaten
            </Typography>

            <Grid container spacing={3}>
              {/* First Name */}
              <Grid item xs={12} md={6}>
                <TextField
                  label="Vorname"
                  fullWidth
                  required
                  value={formData.vorname}
                  onChange={(e) => {
                    setFormData({ ...formData, vorname: e.target.value });
                    setErrors({ ...errors, vorname: false });
                  }}
                  error={Boolean(errors.vorname)}
                  helperText={errors.vorname && "Dieses Feld ist erforderlich"}
                />
              </Grid>

              {/* Last Name */}
              <Grid item xs={12} md={6}>
                <TextField
                  label="Nachname"
                  fullWidth
                  required
                  value={formData.nachname}
                  onChange={(e) => {
                    setFormData({ ...formData, nachname: e.target.value });
                    setErrors({ ...errors, nachname: false });
                  }}
                  error={Boolean(errors.nachname)}
                  helperText={errors.nachname && "Dieses Feld ist erforderlich"}
                />
              </Grid>

              {/* Address */}
              <Grid item xs={12}>
                <Typography variant="h6" fontWeight="bold" mb={2}>
                  Adresse*
                </Typography>

                {/* Street Address */}
                <TextField
                  label="Straße mit Hausnummer"
                  fullWidth
                  required
                  value={formData.straße}
                  onChange={(e) => {
                    setFormData({ ...formData, straße: e.target.value });
                    setErrors({ ...errors, straße: false });
                  }}
                  error={Boolean(errors.straße)}
                  helperText={errors.straße && "Dieses Feld ist erforderlich"}
                  sx={{ mb: 2 }}
                />

                {/* City */}
                <TextField
                  label="Stadt"
                  fullWidth
                  required
                  value={formData.stadt}
                  onChange={(e) => {
                    setFormData({ ...formData, stadt: e.target.value });
                    setErrors({ ...errors, stadt: false });
                  }}
                  error={Boolean(errors.stadt)}
                  helperText={errors.stadt && "Dieses Feld ist erforderlich"}
                  sx={{ mb: 2 }}
                />

                {/* Postal Code */}
                <TextField
                  label="Postleitzahl"
                  fullWidth
                  required
                  value={formData.plz}
                  onChange={(e) => {
                    setFormData({ ...formData, plz: e.target.value });
                    setErrors({ ...errors, plz: false });
                  }}
                  error={Boolean(errors.plz)}
                  helperText={errors.plz && "Dieses Feld ist erforderlich"}
                  sx={{ mb: 2 }}
                />
              </Grid>

              {/* Preferred Contact Method */}
              <Grid item xs={12}>
                <Typography variant="h6" fontWeight="bold" mb={2}>
                  Bevorzugte Kontaktmöglichkeit*
                </Typography>
                <TextField
                  fullWidth
                  required
                  select
                  value={selectedContactMethod}
                  onChange={handleContactMethodChange}
                  label="Kontaktmethode"
                  sx={{ mb: 2 }}
                >
                  {contactMethods.map((method) => (
                    <MenuItem key={method.value} value={method.value}>
                      {method.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Phone / Email */}
              <Grid item xs={12}>
                <TextField
                  label="Telefon / Email"
                  fullWidth
                  required
                  value={formData.telefon}
                  onChange={(e) => {
                    setFormData({ ...formData, telefon: e.target.value });
                    setErrors({ ...errors, telefon: false });
                  }}
                  error={Boolean(errors.telefon)}
                  helperText={errors.telefon && "Dieses Feld ist erforderlich"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {selectedContactMethod === "phone" ? (
                          <FaPhoneAlt />
                        ) : (
                          <FaEnvelope />
                        )}
                      </InputAdornment>
                    ),
                  }}
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </Box>
        )}
      </form>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 10,
          mb: 10,
          maxWidth: 1200,
          mx: "auto",
        }}
      >
        <Button
          variant="contained"
          color="grey"
          onClick={handleBack}
          disabled={step === 1}
          sx={{
            px: 4,
            py: 2,
            color: "gray.800",
            backgroundColor: "gray.300",
            "&:hover": {
              backgroundColor: "gray.400",
            },
          }}
        >
          Zurück
        </Button>

        <Button
          variant="contained"
          onClick={handleNext}
          sx={{
            px: 6,
            py: 2,
            backgroundColor: "#70C9C0",
            color: "white",
            "&:hover": {
              backgroundColor: "#2abbac",
            },
          }}
        >
          {step === 5 ? "Absenden" : "Weiter"}
        </Button>
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          Angebot wurde erfolgreich gesendet!
        </Alert>
      </Snackbar>
      <Footer />
    </div>
  );
};

export default Cleaningform;
